import { Atom } from ":mods";
import {OTPProps } from "../../models";
import { createOTPInputs } from "../../forms";

export function OTP({ onOTPSuccess }: { onOTPSuccess?: (body: OTPProps) => void }) {
  const FormInputs = createOTPInputs();

  const onDataChange = (otp: string) => {
    FormInputs.OTP.control.setValue(otp);
  };
  const onSubmit = async (e:Event) => {
    e.preventDefault();
    const body: OTPProps = {
      otp: FormInputs.OTP.control.value,
      email: undefined,
    };

    if (onOTPSuccess) {
      if (!!FormInputs.OTP.control.value) {
        await onOTPSuccess(body);
      } else {
        onOTPSuccess(undefined);
      }
    }
  };
  return (
    <section class="flex flex-col !font-rubik$ w-full h-full items-center justify-center">
      <form class="flex flex-col text-center gap-40px !font-rubik$ w-500px h-fit bg#pt text#p rounded-lg p-40px ">
        <h1 class={`font-bold text-31px`}>Enter verification code</h1>
        <p class="text-16px font-normal ">
          we sent you an email with a verification code, please enter the code to continue.
        </p>
        <FormInputs.OTP.Input class="hidden" />
        <Atom.OTP.OTP onOTPChange={onDataChange} />

        <FormInputs.Actions.Button
          statusValid="Verify"
          statusInvalid="Verify invalid"
          class="form-btn text-16px font-bold p-15px h-54px cursor-pointer"
          onclick={onSubmit}
        />
      </form>
    </section>
  );
}
